import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const FilterErrorIconGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('#D41515', props);
  const strokeColor = toSvgColor('white', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        d="M14.6663 7.9987C14.6663 8.87418 14.4939 9.74108 14.1589 10.5499C13.8238 11.3588 13.3328 12.0937 12.7137 12.7127C12.0947 13.3318 11.3597 13.8229 10.5509 14.1579C9.74206 14.4929 8.87515 14.6654 7.99967 14.6654C7.1242 14.6654 6.25729 14.4929 5.44845 14.1579C4.63961 13.8229 3.90469 13.3318 3.28563 12.7127C2.66657 12.0937 2.17551 11.3588 1.84048 10.5499C1.50545 9.74108 1.33301 8.87418 1.33301 7.9987C1.33301 6.23059 2.03539 4.5349 3.28563 3.28465C4.53587 2.03441 6.23156 1.33203 7.99967 1.33203C9.76779 1.33203 11.4635 2.03441 12.7137 3.28465C13.964 4.5349 14.6663 6.23059 14.6663 7.9987Z"
        fill={fillColor}
      />
      <path
        d="M8 5.33203V7.9987M8 10.6654H8.00667"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  );
};

export const FilterErrorIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...(props.svg ?? {})}
    >
      <FilterErrorIconGroup {...props} />
    </svg>
  );
};
